
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroExperiencias from './components/HeroExperiencias';
import PasseiosMota from './components/PasseiosMota';
import LevadasSection from './components/LevadasSection';
import GolfinhoSection from './components/GolfinhoSection';
import PraiasSection from './components/PraiasSection';
import RestaurantesSection from './components/RestaurantesSection';
import CTAExperiencias from './components/CTAExperiencias';

const ExperienciasPage = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <HeroExperiencias />

        {/* Quick Nav */}
        <nav className="sticky top-20 z-40 bg-white border-b border-gray-100 shadow-sm">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="flex items-center gap-1 overflow-x-auto py-3 scrollbar-hide">
              {[
                { label: 'Mota 4', href: '#passeios-mota', icon: 'ri-motorbike-line' },
                { label: 'Levadas', href: '#levadas', icon: 'ri-footprint-line' },
                { label: 'Golfinhos', href: '#golfinhos', icon: 'ri-ship-line' },
                { label: 'Praias', href: '#praias', icon: 'ri-sun-line' },
                { label: 'Restaurantes', href: '#restaurantes', icon: 'ri-restaurant-line' },
              ].map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  className="flex items-center gap-2 px-5 py-2 rounded-full text-sm font-medium text-gray-600 hover:bg-sea-blue/10 hover:text-sea-blue transition-all whitespace-nowrap cursor-pointer"
                >
                  <i className={`${item.icon} text-base`}></i>
                  {item.label}
                </a>
              ))}
            </div>
          </div>
        </nav>

        <PasseiosMota />
        <LevadasSection />
        <GolfinhoSection />
        <PraiasSection />
        <RestaurantesSection />
        <CTAExperiencias />
      </main>
      <Footer />
    </div>
  );
};

export default ExperienciasPage;
